// Modified from: https://github.com/nkbt/react-debounce-input

import React, { Component } from 'react';
import debounce from 'lodash/debounce';

import Input from '@klarna/ui/uncontrolled/Input';

export default class DebounceInput extends Component {
  constructor(props) {
    super(props);

    this.state = { value: this.props.initialValue || this.props.value || '' };
    this.onChange = this.onChange.bind(this);
    this.forceNotify = this.forceNotify.bind(this);
    this.createNotifier = this.createNotifier.bind(this);
  }

  componentWillMount() {
    this.createNotifier(this.props.debounceTimeout);
  }

  componentWillReceiveProps({ value, debounceTimeout }) {
    if (typeof value !== 'undefined' && this.state.value !== value) {
      this.setState({ value });
    }
    if (debounceTimeout !== this.props.debounceTimeout) {
      this.createNotifier(debounceTimeout);
    }
  }

  componentWillUnmount() {
    if (this.notify.cancel) {
      this.notify.cancel();
    }
  }

  onChange(event) {
    event.persist();

    const oldValue = this.state.value;

    this.setState({ value: event.target.value }, () => {
      const { value } = this.state;

      if (value.length >= this.props.minLength) {
        this.notify(event);
        return;
      }

      // If user hits backspace and goes below minLength consider it cleaning the value
      if (oldValue.length > value.length) {
        this.notify({ ...event, target: { ...event.target, value: '' } });
      }
    });
  }

  forceNotify(event) {
    if (this.notify.cancel) {
      this.notify.cancel();
    }

    const { value } = this.state;
    const { minLength, onChange } = this.props;

    if (value.length >= minLength) {
      onChange(event);
    } else {
      onChange({ ...event, target: { ...event.target, value } });
    }
  }

  createNotifier(debounceTimeout) {
    if (debounceTimeout < 0) {
      this.notify = () => null;
    } else if (debounceTimeout === 0) {
      this.notify = this.props.onChange;
    } else {
      this.notify = debounce(this.props.onChange, debounceTimeout);
    }
  }

  render() {
    /* eslint no-unused-vars: 0 */
    const {
      onChange: _onChange,
      value: _value,
      minLength: _minLength,
      debounceTimeout: _debounceTimeout,
      forceNotifyByEnter,
      forceNotifyOnBlur,
      initialValue,
      ...props // eslint-disable-line comma-dangle
    } = this.props;

    const onKeyDown = forceNotifyByEnter ? {
      onKeyDown: (event) => {
        if (event.key === 'Enter') {
          this.forceNotify(event);
        }
        // Invoke original onKeyDown if present
        if (this.props.onKeyDown) {
          this.props.onKeyDown(event);
        }
      },
    } : {};

    const onBlur = forceNotifyOnBlur ? {
      onBlur: (event) => {
        this.forceNotify(event);
        // Invoke original onBlur if present
        if (this.props.onBlur) {
          this.props.onBlur(event);
        }
      },
    } : {};

    if (this.props.type === 'search') {
      return (
        <Input
          icon="search"
          type="search"
          label={this.props.label || ''}
          {...props}
          value={this.state.value}
          onChange={this.onChange}
          {...onKeyDown}
          {...onBlur}
        />
      );
    }

    return (
      <Input
        type="text"
        label={this.props.label || ''}
        {...props}
        value={this.state.value}
        onChange={this.onChange}
        {...onKeyDown}
        {...onBlur}
      />
    );
  }
}

DebounceInput.propTypes = {
  onChange: React.PropTypes.func.isRequired,
  onKeyDown: React.PropTypes.func,
  onBlur: React.PropTypes.func,
  value: React.PropTypes.string,
  minLength: React.PropTypes.number,
  debounceTimeout: React.PropTypes.number,
  forceNotifyByEnter: React.PropTypes.bool,
  forceNotifyOnBlur: React.PropTypes.bool,
};

DebounceInput.defaultProps = {
  minLength: 0,
  debounceTimeout: 100,
  forceNotifyByEnter: true,
  forceNotifyOnBlur: true,
};



// WEBPACK FOOTER //
// ./src/app/components/common/DebounceInput.js